export const dataGridStyles = {
    fixedCellsContainer: {
        display: "flex",
        position: "sticky",
        zIndex: 3,
        left: 0,
        boxSizing: "border-box"
    },
    fixedHeader: {
        display: "flex",
        position: "absolute",
        left: 0,
        zIndex: 10,
        width: "auto",
        height: 40
    },
    groupedCell: {
        paddingLeft: "0.3em",
        display: "flex"
    }
};
